/*
A Territory is a distinct playable location that a unit can go to.
The north/south coasts of STP, SPA, BUL are considered separate
territories.

See also Province.ts.

This is the internal type that we mostly use in this codebase to 
enumerate this notion. From the API we also have to work with
territory IDs ("terrID") quite often though. 

See GameStateMaps.ts for converting Territories to/from IDs.
See TerritoryMap for getting the data about the province
that contains a territory.
*/

enum Territory {
  ADRIATIC_SEA = "ADRIATIC_SEA",
  AEGEAN_SEA = "AEGEAN_SEA",
  ALBANIA = "ALBANIA",
  ANKARA = "ANKARA",
  APULIA = "APULIA",
  ARMENIA = "ARMENIA",
  BALTIC_SEA = "BALTIC_SEA",
  BARENTS_SEA = "BARENTS_SEA",
  BELGIUM = "BELGIUM",
  BERLIN = "BERLIN",
  BLACK_SEA = "BLACK_SEA",
  BOHEMIA = "BOHEMIA",
  BREST = "BREST",
  BUDAPEST = "BUDAPEST",
  BULGARIA = "BULGARIA",
  BULGARIA_NORTH_COAST = "BULGARIA_NORTH_COAST",
  BULGARIA_SOUTH_COAST = "BULGARIA_SOUTH_COAST",
  BURGUNDY = "BURGUNDY",
  CLYDE = "CLYDE",
  CONSTANTINOPLE = "CONSTANTINOPLE",
  DENMARK = "DENMARK",
  EASTERN_MEDITERRANEAN = "EASTERN_MEDITERRANEAN",
  EDINBURGH = "EDINBURGH",
  ENGLISH_CHANNEL = "ENGLISH_CHANNEL",
  FINLAND = "FINLAND",
  GALICIA = "GALICIA",
  GASCONY = "GASCONY",
  GREECE = "GREECE",
  GULF_OF_BOTHNIA = "GULF_OF_BOTHNIA",
  GULF_OF_LYONS = "GULF_OF_LYONS",
  HELIGOLAND_BIGHT = "HELIGOLAND_BIGHT",
  HOLLAND = "HOLLAND",
  IONIAN_SEA = "IONIAN_SEA",
  IRISH_SEA = "IRISH_SEA",
  KIEL = "KIEL",
  LIVERPOOL = "LIVERPOOL",
  LIVONIA = "LIVONIA",
  LONDON = "LONDON",
  MARSEILLES = "MARSEILLES",
  MIDDLE_ATLANTIC = "MIDDLE_ATLANTIC",
  MOSCOW = "MOSCOW",
  MUNICH = "MUNICH",
  NAPLES = "NAPLES",
  NORTH_AFRICA = "NORTH_AFRICA",
  NORTH_ATLANTIC = "NORTH_ATLANTIC",
  NORTH_SEA = "NORTH_SEA",
  NORWAY = "NORWAY",
  NORWEGIAN_SEA = "NORWEGIAN_SEA",
  PARIS = "PARIS",
  PICARDY = "PICARDY",
  PIEDMONT = "PIEDMONT",
  PORTUGAL = "PORTUGAL",
  PRUSSIA = "PRUSSIA",
  ROME = "ROME",
  RUHR = "RUHR",
  RUMANIA = "RUMANIA",
  SAINT_PETERSBURG = "SAINT_PETERSBURG",
  SAINT_PETERSBURG_NORTH_COAST = "SAINT_PETERSBURG_NORTH_COAST",
  SAINT_PETERSBURG_SOUTH_COAST = "SAINT_PETERSBURG_SOUTH_COAST",
  SERBIA = "SERBIA",
  SEVASTOPOL = "SEVASTOPOL",
  SILESIA = "SILESIA",
  SKAGERRACK = "SKAGERRACK",
  SMYRNA = "SMYRNA",
  SPAIN = "SPAIN",
  SPAIN_NORTH_COAST = "SPAIN_NORTH_COAST",
  SPAIN_SOUTH_COAST = "SPAIN_SOUTH_COAST",
  SWEDEN = "SWEDEN",
  SYRIA = "SYRIA",
  TRIESTE = "TRIESTE",
  TUNIS = "TUNIS",
  TUSCANY = "TUSCANY",
  TYROLIA = "TYROLIA",
  TYRRHENIAN_SEA = "TYRRHENIAN_SEA",
  UKRAINE = "UKRAINE",
  VENICE = "VENICE",
  VIENNA = "VIENNA",
  WALES = "WALES",
  WARSAW = "WARSAW",
  WESTERN_MEDITERRANEAN = "WESTERN_MEDITERRANEAN",
  YORK = "YORK",
}

export default Territory;
